import type { Components, Theme } from '@mui/material';

import { borderRadius, colors, shadows, spacing } from '@verantos-dev/shared-ui-components/tokens';

export const dataGridThemeConfig: Components<Theme>['MuiDataGrid'] = {
  styleOverrides: {
    root: {
      boxShadow: shadows.md,
      border: 1,
      borderColor: colors['neutral-100'],
      borderRadius: `${borderRadius.md}px`,
    },
    row: {
      height: 'auto !important',
      minHeight: '48px !important',
      maxHeight: '100px !important',
      '&:hover': {
        // TODO: no VDS token for this value (rgba(204, 240, 249, 0.608)) — needs designer input (Barry Richardson)
        backgroundColor: 'rgba(204, 240, 249, 0.608)',
      },
      // TODO: no VDS token for this value (rgba(0, 0, 0, 0.02)) — needs designer input (Barry Richardson)
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      '&:nth-of-type(odd)': {
        backgroundColor: colors.white,

        '&:hover': {
          // TODO: no VDS token for this value (rgba(204, 240, 249, 0.608)) — needs designer input (Barry Richardson)
          backgroundColor: 'rgba(204, 240, 249, 0.608)',
        },
      },
    },
    withBorderColor: {
      borderColor: 'transparent', // border between rows
    },
    columnHeaderTitle: {
      padding: `${spacing[4]}px ${spacing[6]}px`,
      fontSize: 14,
      fontWeight: 500,
      // TODO: no VDS token for this value (#252A36) — needs designer input (Barry Richardson)
      color: '#252A36',
    },
    columnHeader: {
      backgroundColor: colors.white,
      borderBottom: `1px solid ${colors['neutral-100']} !important`,
      padding: 0,
      '&.menuIcon': {
        marginRight: 0,
      },
      '&:focus': {
        outline: 'none',
      },
      '&:focus-within': {
        outline: 'none',
      },
    },
    menuIcon: {
      marginRight: 0,
      zIndex: '110',
    },
    cell: {
      padding: `${spacing[4]}px ${spacing[6]}px`,
      // TODO: no VDS token for this value (#51555e) — needs designer input (Barry Richardson)
      color: '#51555e',
      // hide the border between cells when clicking on a cell
      '&:focus': {
        outline: 'none',
        border: 'none',
      },
      '&.MuiDataGrid-cell--editing': {
        outline: 'none',
        border: 'none',
      },
      '&.MuiDataGrid-cellEmpty': {
        padding: 0,
      },
      '&:focus-within': {
        outline: 'none',
        border: 'none',
      },
    },
  },
};

export const tableRowThemeConfig: Components<Theme>['MuiTableRow'] = {
  styleOverrides: {
    root: {
      // TODO: no VDS token for this value ('yellow') — needs designer input (Barry Richardson)
      '&:hover': { backgroundColor: 'yellow' },
    },
  },
};
